import React from "react"
import { graphql } from "gatsby"

import { Meta, PageCircles } from "@shared"
import { CONSTANTS, CONTENT } from "@data"
import { logTool } from "@jsUtils"

import { Footer, Header, HeroGrid, SupportFaqs, Subscribe } from "@components/sections"

import Styles from "./support.module.scss"

const { PAGE_NAMES, THEMES, COLORS, PAGE_TRACKER_KEYS, PAGE_TRACKER_VALUES } = CONSTANTS
const { SUPPORT } = CONTENT

const log = logTool()

/**
 * Render a support page with this template
 * @param {object} props - react props
 */
const Support = props => {
  const { pageContext, data } = props
  const { contentfulSupportPage, contentfulPageMeta } = data
  const { otherPages } = pageContext

  const hero = {
    headline: SUPPORT.headline,
    eyebrow: SUPPORT.eyebrow,
    subhead: SUPPORT.subhead
  }

  log("Render Support Page:", { contentfulSupportPage, otherPages, contentfulPageMeta })

  return (
    <>
      <Meta
        base={contentfulPageMeta}
        page={contentfulSupportPage}
        hubSpotObj={{
          contentTypeKey: PAGE_TRACKER_KEYS.PRODUCT_PAGES,
          contentTypeValue: PAGE_TRACKER_VALUES.WEBSITE_PAGE
        }}
      />

      <Header theme={THEMES.TIN} pageColor={COLORS.DARK} />
      <HeroGrid
        shortHeroSection
        theme={THEMES.TIN}
        color={COLORS.FLURO}
        page={PAGE_NAMES.SUPPORT}
        content={hero}
      />
      <PageCircles
        settings={{
          align: "right",
          color: COLORS.FLURO,
          fromTop: "calc(30% - 20vw)",
          orbit: true,
          size: "large",
          extraClasses: {
            wrapper: Styles.circleWrap
          }
        }}
      />
      <SupportFaqs
        data={contentfulSupportPage}
        relatedPages={otherPages}
        currentPage={pageContext.slug}
      />
      <Subscribe theme={THEMES.DARK} color={COLORS.FLURO} />
      {/* <GetInTouch color={COLORS.FLURO} theme={THEMES.DARK} /> */}
      <Footer />
    </>
  )
}

export default Support

export const pageQuery = graphql`
  query($slug: String!) {
    contentfulPageMeta(id: { eq: "423babd8-0278-5b2e-85f6-77fb7ee55bee" }) {
      ...GlobalMetaData
    }
    contentfulSupportPage(slug: { eq: $slug }) {
      slug
      title
      pageMeta {
        ...PageMetaData
      }
      supportItems {
        id
        title
        content {
          childMarkdownRemark {
            html
          }
        }
      }
    }
  }
`
